import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { setFontVariant } from "@similarweb/styles";
import { FlexRow, FlexColumn } from "@similarweb/ui-components";

import { RankTrackerTooltip } from "app/components/campaigns/shared/RankTrackerTooltip";

export const TooltipContentWrapper = styled(FlexColumn)`
    padding: 6px 0;
`;

export const PopupHoverContainerTitle = styled.div`
    margin-bottom: 4px;
    ${setFontVariant("subtitle1")};
`;

export const PopupHoverContainerUrl = styled.div`
    ${setFontVariant("listItem3")};
    line-height: 16px;
    word-break: break-all;
    overflow: hidden;
    white-space: initial;
    letter-spacing: 0.5px;
`;

export const PopupHoverContainerYourUrlTitleWrapper = styled(FlexRow)`
    margin-top: 24px;
`;

export const PopupHoverIcon = styled(SWReactIcons)`
    margin-top: 2px;
`;

export const PopupHoverContainerYourUrlTitle = styled.div`
    margin-bottom: 10px;
    margin-left: 8px;
    ${setFontVariant("listItem1")};
`;

export const PopupHoverContainerYourUrlText = styled.div`
    ${setFontVariant("listItem1")};
`;

export const PopupHoverContainerYourUrl = styled.div`
    ${setFontVariant("listItem3")};
    line-height: 16px;
    word-break: break-all;
    overflow: hidden;
    white-space: initial;
    letter-spacing: 0.5px;
`;

export const IconButtonWrapper = styled.div<{ color?: string }>`
    margin-left: auto;
    .SWReactIcons {
        svg {
            path {
                fill: ${({ color }) => color} !important;
                fill-opacity: 1;
                transition: fill 200ms ease-out;
            }
        }
    }
`;

export const Wrapper = styled(FlexRow)`
    align-items: center;
    width: 100%;
    justify-content: space-between;
    box-sizing: border-box;
`;

export const WiderRankTrackerTooltip = styled(RankTrackerTooltip)`
    && {
        max-width: 320px;
    }
`;
